import React, { useEffect, useState } from 'react'
import ReactMapGL from 'react-map-gl';
import LocationMarker from './LocationMarker';
import Loader from './Loader'


const Map = ({ center, zoom }) => {

    const [eventData, setEventData] = useState([])
    const [loading, setLoading] = useState([])

    useEffect(() => {
        const fetchEvents = async () => {
            const res = await fetch('https://eonet.gsfc.nasa.gov/api/v2.1/events')
            const { events } = await res.json()

            setEventData(events)
            setLoading(false)
        }
        fetchEvents()
    }, [])

    const [viewport, setViewport] = useState({
        width: "100%",
        height: "100%",
        latitude: 48.4284,
        longitude: -123.3656,
        zoom: 8
    });
    return (
        <>
            {!loading ?
                (
                    <ReactMapGL
                        {...viewport}
                        mapboxApiAccessToken={process.env.REACT_APP_MAPBOX}
                        onViewportChange={nextViewport => setViewport(nextViewport)}
                        mapStyle={process.env.REACT_APP_MAPSTYLE}
                    >
                        <LocationMarker mark={eventData} />
                    </ReactMapGL>
                ) :
                (
                    <Loader />
                )
            }
        </>
    )
}


export default Map
